export default {
  common: {
    price: '{{currency}} {{amount}}',
    dateRange: '{{from}} - {{to}}',
    currencyJpy: 'JPY',
    suggestVisitingTime: '建议游玩时长',
    searchIcon: '✦',
    zoomIn: '+',
    zoomOut: '−',
    back: '←'
  },
  home: {
    searchPlaceholder: '告诉我你想去什么地方...',
    scale800m: '徒步15分钟 (800m)',
    scale2km: '地铁2站以内 (2km)',
    scale5km: '地铁5站以内 (5km)',
    nearbyCount: '共 {{count}} 个地点',
    listMode: '列表模式',
    mapMode: '地图模式',
    exploreNearby: '探索附近',
    filterAll: '全部',
    tataGreeting: '嗨，我是tata!\n看看{{city}}还有哪些好玩的地方吧～',
    tataGreetingFallback: '你好，我是tata\n我们一起发现更多有趣的好去处吧～'
  },
  search: {
    noResults: '暂无结果',
    youMayLike: '猜你喜欢',
    whereNext: '接下来去哪？'
  },
  booking: {
    ticketInfo: '门票信息',
    viewTicket: '查看电子票券',
    plan: '套餐',
    date: '参加日期',
    participants: '参加人数',
    highlights: '亮点推荐',
    openingHours: '营业时间',
    address: '地址',
    officialSite: '官网',
    goingTo: '即将前往{{title}}',
    nextStation: '开启下一站'
  },
  profile: {
    backToMap: '返回地图',
    my: '我的',
    tickets: '票券',
    favourites: '收藏',
    exploreMore: '探索更多',
    viewMap: '查看地图'
  },
  bookmarks: {
    myBookmarks: '我的收藏',
    empty: '暂无收藏'
  },
  tickets: {
    myTickets: '我的票券',
    quantity: '数量',
    viewTicket: '查看票券',
    empty: '暂无票券'
  },
  voucher: {
    scanCode: '请扫码',
    useEticket: '点击使用电子票券',
    ticketDetail: '票券详情',
    notification: '具体信息及人工换票时请点击「票券详情」',
    orderId: '订单ID：{{id}}'
  },
  poi: {
    highlights: '亮点推荐',
    openingHours: '营业时间',
    address: '地址',
    officialWebsite: '官网链接',
    adultTicket: '成人门票',
    priceFrom: '{{price}} 起',
    buyTicket: '去购票',
    viewDetails: '查看详情',
    freeAdmission: '免费入场',
    ratingCount: '{{n}}人评分',
    star: '★',
    clock: '🕐',
    nearbyRecommend: '周边推荐',
    recentEvents: '近期活动',
    distanceTo: '距{{name}} {{distance}}',
    aiGenerated: '此内容由AI生成',
    goingTo: '即将前往',
    categories: {
      experience: '体验',
      nature: '自然',
      attraction: '景点',
      gourmet: '美食',
      shopping: '购物'
    }
  },
  event: {
    tag: '活动',
    period: '活动时间',
    duration: '游玩时长',
    officialWebsite: '活动官网'
  }
};
